import { render, staticRenderFns } from "./FormContrapartidas.vue?vue&type=template&id=b87c9bb8"
import script from "./FormContrapartidas.vue?vue&type=script&lang=js"
export * from "./FormContrapartidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports